module.exports = __webpack_public_path__ + "img/card-bg2.5a3c2b67.png";